/* eslint-disable-next-line */
import Swiper from 'swiper/bundle'; // NOSONAR
import SwiperExt from '../swiper';

const { feWp } = window;
const { addFilter } = feWp.hooks;

addFilter( 'b3rg_slider_library', 'b3rg/slider', () => {
  return SwiperExt;
} );

addFilter(
  'b3rg_slider_extend',
  'b3rg/slider',
  ( defaultSliderSettings, element ) => {
    if ( element.closest( '.e-sld--rating-slider-with-left-side-content' ) ) {
      const originalOn = defaultSliderSettings.on || {};

      defaultSliderSettings.on = {
        ...originalOn,
        autoplayPause: function ( swiper ) {
          swiper.once( 'transitionEnd', () => {
            if ( swiper.autoplay.running && swiper.autoplay.paused ) {
              swiper.autoplay.resume();
            }
          } );
        },
      };
    }
    return defaultSliderSettings;
  }
);
